
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { WorksheetOption } from './types';
import { hasAvailableSheets } from './utils';

interface WorksheetOptionLabelProps {
  option: WorksheetOption;
}

const WorksheetOptionLabel: React.FC<WorksheetOptionLabelProps> = ({ option }) => {
  return (
    <div className="flex justify-between items-center w-full">
      <div>{`${option.worksheet.name} - ${option.worksheet.subject} (${option.worksheet.grade_level})`}</div>
      {hasAvailableSheets(option.worksheet) && (
        <Badge variant="success" className="ml-2 text-xs">มีชีท</Badge>
      )}
    </div>
  );
};

export default WorksheetOptionLabel;
